import { cx } from "class-variance-authority";
import { getChildByType } from "react-nanny";
import { Slot } from "../../../components/layouts/slot";

const Header = Slot();
const DesktopSidebar = Slot();
const MobileSidebar = Slot();
const Content = Slot();

const Container = (props: {
  children: React.ReactNode;
  desktopSidebarContainerClass?: string;
}) => {
  const header = props.children ? getChildByType(props.children, Header) : null;
  const desktopSidebar = props.children
    ? getChildByType(props.children, DesktopSidebar)
    : null;
  const content = props.children
    ? getChildByType(props.children, Content)
    : null;

  return (
    <main className="relative grid grid-rows-[70px] w-screen h-screen bg-offwhiteVariant overflow-hidden">
      {header ? header : <div />}
      <div className="h-full relative overflow-y-auto">
        <div className="mx-auto lg:flex px-6 gap-x-8 lg:max-w-[1280px]">
          <div
            className={cx(
              "hidden lg:flex",
              "sticky top-0",
              "sticky h-full top-0",
              props.desktopSidebarContainerClass
            )}
          >
            {desktopSidebar ? desktopSidebar : <div />}
          </div>
          <div className="h-full flex-1 overflow-hidden">
            {content ? content : <div />}
          </div>
        </div>
      </div>
    </main>
  );
};

export const StickySidebarPageLayout = {
  Container,
  Header,
  DesktopSidebar,
  MobileSidebar,
  Content,
};
